<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                v-if="this.filter.user_id != ''"
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.push('/point-mapping-logs')"
              >
                <v-icon dark> mdi-arrow-left </v-icon>
              </v-btn>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Point Mapping Log'
                    : 'Deleted Point Mapping Log'
                "
              ></h3>
              <!-- <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/point-mapping-logs/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template> -->
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.position_id"
                    :items="positionItems"
                    clearable
                    @click:clear="(filter.position_id = null), (page = 1)"
                    label="Position"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <!-- Month Year -->
                <v-col sm="3">
                  <v-menu
                    v-model="month_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.month_year"
                        label="Year - Month"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="
                          () => {
                            filter.month_year = null;
                            getData();
                          }
                        "
                        hide-details
                        :error-messages="errors.month"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.month_year"
                      type="month"
                      @input="
                        getData();
                        month_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /Month Year -->
                <!-- Start date -->
                <v-col sm="3">
                  <v-menu
                    v-model="start_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.start_date"
                        label="Start Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="
                          () => {
                            filter.start_date = null;
                            getData();
                          }
                        "
                        hide-details
                        :error-messages="errors.start_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.start_date"
                      @input="
                        getData();
                        start_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /Start date -->
                <!-- End date -->
                <v-col sm="3">
                  <v-menu
                    v-model="end_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.end_date"
                        label="End Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="
                          () => {
                            filter.end_date = null;
                            getData();
                          }
                        "
                        hide-details
                        :error-messages="errors.end_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.end_date"
                      @input="
                        getData();
                        end_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /End date -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      rounded
                      x-small
                      depressed
                      color="error"
                      class="my-auto"
                      @click="deleteAll(point_mapping_logs.id)"
                      style="width: 90px; height: 50px"
                    >
                      <v-icon dark> mdi-delete </v-icon>
                    </v-btn>
                  </template>
                  <span>Delete all Store</span>
                </v-tooltip>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="point_mapping_logs.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                large
                class="primary"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else

                class="striped-table"
              >
                <template v-slot:default v-if="this.filter.user_id == ''">
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th>
                      <th class="text-left">Status</th>
                      <th class="text-left">User</th>
                      <th class="text-left">Total Earned Points</th>
                      <th class="text-left">Use Points</th>
                      <th class="text-left" style="min-width: none">
                        Total Available Points
                      </th>
                      <th class="text-left" style="min-width: none">Date</th>
                      <!-- <th class="text-left" style="min-width: none">Date</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Validity</th> -->
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>

                  <tbody
                    v-if="point_mapping_logs && point_mapping_logs.length != 0"
                  >
                    <tr
                      v-for="(point_mapping_log, i) in point_mapping_logs"
                      :key="`point_mapping_log_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': point_mapping_logs.length - 1 == i,
                      }"
                    >
                      <td>
                        <input
                          type="checkbox"
                          v-model="point_mapping_log.is_selected"
                        />
                        &nbsp;{{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="point_mapping_log.is_active == 1"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Point Mapping Log is Active</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="point_mapping_log.is_active == 0"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Point Mapping Log is InActive</span>
                        </v-tooltip>
                      </td>

                      <td>
                        {{
                          point_mapping_log.user
                            ? point_mapping_log.user.first_name
                            : ""
                        }}
                      </td>
                      <td>
                        {{ point_mapping_log.total_points || "" }}
                      </td>
                      <td>
                        {{ point_mapping_log.use_points || "" }}
                      </td>
                      <td>
                        {{ point_mapping_log.total_available_points || "" }}
                      </td>
                      <td>
                        {{ point_mapping_log.created_at || "" }}
                      </td>
                      <!-- <td>
                        {{
                          point_mapping_log.status == 1 ? "COMPLETED" : "PENDING"
                        }}
                      </td>
                      <td>{{ point_mapping_log.valid_till || "" }}</td> -->
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-2 mb-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/point-mapping-logs?user_id=${encryptIt(
                                  point_mapping_log.user.id
                                )}`"
                              >
                                <v-icon dark>mdi mdi-eye</v-icon>
                              </v-btn>
                            </template>
                            <span>View point Wise Details</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(point_mapping_log.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Gift</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/poin-mapping-logs/${encryptIt(
                                  point_mapping_log.id
                                )}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Gift</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(point_mapping_log.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this point_mapping_log</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
                <template v-slot:default v-else>
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th>
                      <th class="text-left">Status</th>
                      <th class="text-left">User</th>
                      <th class="text-left">Product</th>
                      <th class="text-left">Unit in ltr</th>
                      <th class="text-left">Point Type</th>
                      <th class="text-left">Point Status</th>
                      <th class="text-left">Points</th>
                      <th class="text-left" style="min-width: none">Date</th>

                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>

                  <tbody
                    v-if="point_mapping_logs && point_mapping_logs.length != 0"
                  >
                    <tr
                      v-for="(point_mapping_log, i) in point_mapping_logs"
                      :key="`point_mapping_log_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': point_mapping_logs.length - 1 == i,
                      }"
                    >
                      <td>
                        <input
                          type="checkbox"
                          v-model="point_mapping_log.is_selected"
                        />
                        &nbsp;{{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="point_mapping_log.is_active == 1"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Point Mapping Log is Active</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="point_mapping_log.is_active == 0"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Point Mapping Log is InActive</span>
                        </v-tooltip>
                      </td>

                      <td>
                        {{
                          point_mapping_log.user
                            ? point_mapping_log.user.first_name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          point_mapping_log.product
                            ? point_mapping_log.product.name
                            : ""
                        }}
                      </td>
                      <td>
                        {{ point_mapping_log.unit_in_liter || "" }}
                      </td>
                      <td>
                        <strong :class="`${pointTypeColor(point_mapping_log.point_type)}--text`">
                          {{ pointTypeLabel(point_mapping_log.point_type) }}
                        </strong>
                      </td>
                      <td>
                        <strong :class="`${pointStatusColor(point_mapping_log.point_status)}--text`">
                          {{ pointStatusLabel(point_mapping_log.point_status) }}
                        </strong>
                      </td>
                      <td>
                        <span
                          :class="pointStatusTextClass(point_mapping_log.point_status)"
                          class="font-weight-bold"
                        >
                          {{ point_mapping_log.point_status == 1 || point_mapping_log.point_status == 3
                            ? (point_mapping_log.use_points || 0)
                            : (point_mapping_log.point || 0) }}
                        </span>
                      </td>
                      <td>
                        {{ point_mapping_log.created_at || "" }}
                      </td>
                      <!-- <td>
                        {{
                          point_mapping_log.status == 1 ? "COMPLETED" : "PENDING"
                        }}
                      </td>
                      <td>{{ point_mapping_log.valid_till || "" }}</td> -->
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(point_mapping_log.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Gift</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/poin-mapping-logs/${encryptIt(
                                  point_mapping_log.id
                                )}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Gift</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(point_mapping_log.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this point_mapping_log</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_point_mapping_log" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Gift deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_point_mapping_log = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_point_mapping_log" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Gift restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_point_mapping_log = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "point_mapping_logsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        is_type: "",
        point: "",
        start_date: "",
        end_date: "",
        month_year: "",
        user_id: "",
        position_id: "",
        is_selected: false,
      },
      point_mapping_logs: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],

      ExportGiftTypes: [],
      positionItems: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_point_mapping_log: false,
      is_deleted_point_mapping_log: false,
      is_restored_point_mapping_log: false,
      is_select_all: false,
      isDeleteAll: false,
      start_menu: false,
      end_menu: false,
      month_menu: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    pointTypeLabel(type) {
      const labels = { 1: "Sale", 2: "Enquiry Bonus", 3: "Booster", 4: "Welcome Bonus", 5: "KYC", 6: "Field Hero", 7: "Gift Redeem" };
      return labels[type] || "Unknown";
    },
    pointTypeColor(type) {
      const colors = { 1: "blue", 2: "purple", 3: "orange", 4: "green", 5: "teal", 6: "indigo", 7: "pink" };
      return colors[type] || "grey";
    },
    pointStatusLabel(status) {
      const labels = { 0: "Earned", 1: "Used", 2: "Earned Return", 3: "Used Return" };
      return labels[status] !== undefined ? labels[status] : "Unknown";
    },
    pointStatusColor(status) {
      const colors = { 0: "green", 1: "red", 2: "teal", 3: "orange" };
      return colors[status] !== undefined ? colors[status] : "grey";
    },
    pointStatusTextClass(status) {
      const classes = { 0: "success--text", 1: "error--text", 2: "teal--text", 3: "orange--text" };
      return classes[status] !== undefined ? classes[status] : "";
    },
    async getMasters() {
      await axios
        .get(`point_mapping_logs/masters`)
        .then((masters) => {
          masters = masters.data;
          //Product
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      // this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.state = this.filter.state ? this.filter.state : "";
      this.filter.city = this.filter.city ? this.filter.city : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.store_id = this.filter.store_id ? this.filter.store_id : "";
      this.filter.month_year = this.filter.month_year
        ? this.filter.month_year
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      if (this.$route.query.user_id) {
        this.filter.user_id = this.decryptIt(this.$route.query.user_id);
      } else {
        this.filter.user_id = "";
      }
      // console.log("is_type", this.filter.is_type);
      // this.filter.show_deleted = this.$route.query.open_trash ? 1 : 2;
      // this.filter.is_type = this.filter.is_type ? this.filter.is_type : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&position_id=" +
        this.filter.position_id +
        "&store_id=" +
        this.filter.store_id +
        "&state=" +
        this.filter.state +
        "&city=" +
        this.filter.city +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&month_year=" +
        this.filter.month_year +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`point_mapping_logs?${query}`)
        .then((response) => {
          this.point_mapping_logs = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },

    async Delete_this(id) {
      this.delete_point_mapping_log = true;
      await axios
        .post(`/point_mapping_logs/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_point_mapping_log = false;
          this.is_deleted_point_mapping_log = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    selectAll() {
      console.log(this.is_select_all);
      this.point_mapping_logs.forEach((point_mapping_log) => {
        point_mapping_log.is_selected = this.is_select_all;
      });
    },
    async deleteAll() {
      this.isDeleteAll = true;
      let deleteallIds = [];
      this.point_mapping_logs.forEach((point_mapping_log) => {
        if (point_mapping_log.is_selected) deleteallIds.push(point_mapping_log);
      });
      await axios
        .post("/point_mapping_logs/alldelete", { deleteallIds })
        .then(() => {
          this.filter.status = "";
          this.getData();
        })
        .catch(function (error) {
          this.getData();
          console.log(error);
        });
      // let response = await axios.post(/sync_users/update_date_all, this.form);
      this.isDeleteAll = false;
    },
    //Generate Excel
    async generateExcel() {
      this.isExcelLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.state = this.filter.state ? this.filter.state : "";
      this.filter.city = this.filter.city ? this.filter.city : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.store_id = this.filter.store_id ? this.filter.store_id : "";
      this.filter.month_year = this.filter.month_year
        ? this.filter.month_year
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      let response = [];
      let query =
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&position_id=" +
        this.filter.position_id +
        "&store_id=" +
        this.filter.store_id +
        "&state=" +
        this.filter.state +
        "&city=" +
        this.filter.city +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&month_year=" +
        this.filter.month_year +
        "&search_keyword=" +
        this.filter.search_keyword;
      response = await axios
        .get(`/point_mapping_logs/excel_export?${query}`)
        .then((response) => window.open(`${response.data.data}`, "_blank"));
      if (response) {
        console.log(response);
      }
      this.isExcelloading = false;
    },
    async Restore_this(id) {
      this.restore_point_mapping_log = true;
      await axios
        .post(`/point_mapping_logs/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_point_mapping_log = false;
          this.is_restored_point_mapping_log = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
  },
};
</script>
